// extracted by mini-css-extract-plugin
export default {"workOrderObjectsTotal":"WorkOrderObjectTotals_workOrderObjectsTotal__yqxRY","workOrderObjectsTotalDetails":"WorkOrderObjectTotals_workOrderObjectsTotalDetails__ocwnJ"};